import React from 'react'
const GlobeIcon = props => {
  const height = props.height || 20
  const width = props.width || 20
  const color = props.color || '#202020'
  const strokeWidth = props.strokeWidth || '1'
  return (
    <svg width={width} height={height} fill={color} viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g transform="translate(-385, -196)" stroke="#000000">
          <g transform="translate(385, 196)">
            <g transform="translate(4, 2)">
              <path
                d="M15.7149462,7.36846994 C17.6169942,10.6632658 17.0737695,14.824138 14.3895852,17.5201761 C11.7054009,20.2162141 7.5469627,20.7777679 4.24381767,18.8902565 C0.94067263,17.002745 -0.686734195,13.1349941 0.273266541,9.45370826 C1.23326728,5.77242245 4.5422277,3.19197065 8.34647623,3.15791569 L11.5043919,3.15791569"
                id="Path"
              ></path>
              <polyline id="Path" points="8.34647623 6.31583137 11.5043919 3.15791569 8.34647623 0"></polyline>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

export default GlobeIcon
